import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'app/global/global.service';
import { DocumentsService } from 'app/main/pages/documents/documents.service';

@Component({
  selector: 'app-resend-email-modal',
  templateUrl: './resend-email-modal.component.html',
  styleUrl: './resend-email-modal.component.scss'
})
export class ResendEmailModalComponent implements OnInit {

  @Input() recipientRoleId: number;
  @Input() documentId: number;

  public recipientRoleForm: FormGroup;
  public loading: boolean = false;
  public submitted: boolean = false;

  constructor (
    private _formBuilder: FormBuilder,
    private _activeModal$: NgbActiveModal,
    private documentService: DocumentsService,
    private _globalService$: GlobalService
  ) {}

  ngOnInit(): void {
    this.recipientRoleForm = this._formBuilder.group({
      recipient_role_id: [this.recipientRoleId, [Validators.required]],
      email: ['', [Validators.required, Validators.email]]
    });
  }



  get form(){
    return this.recipientRoleForm.controls;
  }




  closeModal(){
    this._activeModal$.close({refreshParticipants: 0});
  }



  resendEmail(){
    this.submitted = true;
    if(this.recipientRoleForm.invalid || this.loading) return;

    this.loading = true;
    this.documentService.resendEmail(this.documentId, this.recipientRoleForm.value).subscribe({
      next: () => {
        this.loading = false;
        this.submitted = false; 
        this._activeModal$.close({refreshParticipants: 1});
      },
      error: (error) => {
        this.loading = false;
        this.submitted = false;
        this._globalService$.toastrError(error);
      }
    })
  }
}
